import { defaultFontInput } from './constants/fontFamilies';

const FableticsAvailablePointsBuilderComponent = {
  name: '_AvailablePoints_',
  inputs: [defaultFontInput],
} as const;

export default FableticsAvailablePointsBuilderComponent;
